/**
 * Copyright © 2026 Adnuntius AS.
 */
import {NgModule} from '@angular/core';

import {AdvertisingSharedModule} from '../advertising/advertising-shared.module';
import {RetailProductListPageComponent} from '../retail-product/retail-product-list-page.component';
import {CreativeAttachModalComponent} from './creative-attach-modal.component';
import {CreativeBulkActionModalComponent} from './creative-bulk-action-modal.component';
import {CreativeBulkUploadPageComponent} from './creative-bulk-upload-page.component';
import {CreativeContextActionsComponent} from './creative-context-actions.component';
import {CreativeCopyInBulkModalComponent} from './creative-copy-in-bulk-modal.component';
import {CreativeCopyModalComponent} from './creative-copy-modal.component';
import {CreativeEditPageComponent} from './creative-edit-page.component';
import {CreativeListFiltersComponent} from './creative-list-filters.component';
import {CreativeListPageComponent} from './creative-list-page.component';
import {CreativeRetailProductModalComponent} from './creative-retail-product-modal.component';

const CREATIVE_COMPONENTS = [
  CreativeAttachModalComponent,
  CreativeBulkActionModalComponent,
  CreativeBulkUploadPageComponent,
  CreativeContextActionsComponent,
  CreativeCopyInBulkModalComponent,
  CreativeCopyModalComponent,
  CreativeEditPageComponent,
  CreativeListFiltersComponent,
  CreativeListPageComponent,
  CreativeRetailProductModalComponent
];

@NgModule({
  imports: [
    AdvertisingSharedModule,
    RetailProductListPageComponent
  ],
  declarations: CREATIVE_COMPONENTS,
  exports: CREATIVE_COMPONENTS
})
export class CreativeModule {
}
